export const getSidebarLinks = vm => [
  {
    name: vm.$t('site_versions.title'),
    icon: 'fa fa-globe',
    path: '/site-versions',
    meta: { permissions: ['view site versions'] }
  },
  {
    name: vm.$t('products.title'),
    icon: 'fa fa-shopping-bag',
    path: '/products',
    meta: { permissions: ['view products'] }
  },
  {
    name: vm.$t('riders.title'),
    icon: 'fas fa-snowboarding',
    path: '/riders',
    meta: { permissions: ['view riders'] },
    children: [
      {
        name: vm.$t('riders.categories.title'),
        path: '/riders/categories'
      },
      {
        name: vm.$t('riders.disciplines.title'),
        path: '/riders/disciplines'
      },
      {
        name: vm.$t('riders.title'),
        path: '/riders'
      }
    ]
  },
  {
    name: vm.$t('fighters.title'),
    icon: 'fas fa-trophy',
    path: '/fighters',
    meta: { permissions: ['view fighters'] },
    children: [
      {
        name: vm.$t('fighters.categories.title'),
        path: '/fighters/categories'
      },
      {
        name: vm.$t('fighters.title'),
        path: '/fighters'
      }
    ]
  },
  {
    name: vm.$t('rappers.title'),
    icon: 'fa fa-microphone',
    path: '/rappers',
    meta: { permissions: ['view rappers'] }
  },
  {
    name: vm.$t('news.title'),
    icon: 'fas fa-newspaper',
    path: '/news',
    meta: { permissions: ['view news'] },
    children: [
      {
        name: vm.$t('news.categories.title'),
        path: '/news/categories'
      },
      {
        name: vm.$t('news.title'),
        path: '/news'
      }
    ]
  },
  {
    name: vm.$t('socials.title'),
    icon: 'fas fa-hashtag',
    path: '/socials',
    meta: { permissions: ['view socials'] }
  },
  {
    name: vm.$t('contacts.title'),
    icon: 'fas fa-address-card',
    path: '/contacts',
    meta: { permissions: ['view contacts'] }
  },
  {
    name: vm.$t('cities.title'),
    icon: 'fas fa-store',
    path: '/cities',
    meta: { permissions: ['view cities'] },
    children: [
      {
        name: vm.$t('cities.countries.title'),
        path: '/cities/countries'
      },
      {
        name: vm.$t('cities.title'),
        path: '/cities'
      }
    ]
  },
  {
    name: vm.$t('feedback.title'),
    icon: 'fas fa-comments',
    path: '/feedback',
    meta: { permissions: ['view feedback'] },
    children: [
      {
        name: vm.$t('feedback.title'),
        path: '/feedback'
      },
      {
        name: vm.$t('feedback.subject.title'),
        path: '/feedback/subject'
      }
    ]
  },
  {
    name: vm.$t('faqs.title'),
    icon: 'fas fa-info',
    path: '/faqs',
    meta: { permissions: ['view faqs'] },
    children: [
      {
        name: vm.$t('faqs.categories.title'),
        path: '/faqs/categories'
      },
      {
        name: vm.$t('faqs.title'),
        path: '/faqs'
      }
    ]
  }
]
